<div class="row align-items-center tree-view-container">
  <div class="col-md-12">
    <kendo-chip *ngFor="let c of getChipLabels()" [label]="c.fullName" [removable]="true" (remove)="onRemove($event)"
      removeIcon="k-icon k-i-close"></kendo-chip>
  </div>
  <kendo-treeview [nodes]="requestUsersFlatList" kendoTreeViewFlatDataBinding kendoTreeViewExpandable idField="userId"
    parentIdField="root" textField="fullName" [loadOnDemand]="false"
    [kendoTreeViewCheckable]="userSectionCheckableSettings()" [checkBy]="userKey" [(checkedKeys)]="selectedUsers"
    [expandedKeys]="expandedKeys" (checkedChange)="handleChecking($event)" [filterSettings]="filterSettings"
    [filter]="searchTerm" [isChecked]="isChecked" (filterStateChange)="onFilterStateChange($event)">
    <ng-template kendoTreeViewNodeTemplate let-dataItem>
      <span>{{ dataItem.fullName }}</span>
    </ng-template>
  </kendo-treeview>
</div>